import { useMemo } from 'react';
import { useAuthContext } from '../contexts/AuthContext';

export const useAuth = () => {
  const { user, loading, isAuthenticated } = useAuthContext();
  
  // Usar useMemo para evitar recriar o objeto user a cada render
  const userObject = useMemo(() => {
    if (!user) return null;
    return {
      uid: user.userId,
      email: user.email,
      displayName: user.displayName,
    };
  }, [user]);
  
  return { 
    user: userObject,
    loading,
    isAuthenticated: isAuthenticated(),
  };
};
